// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"04f7e1a8","488":"4dbbcd63"}[chunkId] + ".chunk.js";
};